import { useContext, useEffect, useState } from "react";

import "./Menu.scss";
import { useNavigate } from "react-router-dom";
import { fetchCategoryListData } from "../services/CategoryServices";
import { Accordion, Button, Dropdown } from "react-bootstrap";
import { usePage } from "../services/PageContext";
import { GlobalFunctionsContext } from "../services/GlobalFunctionsContext";
import { ArrowRight, ChevronRight } from "react-bootstrap-icons";
import { AuthContext } from "../services/AuthContext";
import { LogIn, LogOut, User, UserRoundPlus } from "lucide-react";

function chunkArray(array, size) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export default function Menu({lateral}) {
  const [categorias, setCategorias] = useState([]);
  const navigate = useNavigate();
  const {isAuthenticated, logout} = useContext(AuthContext)

  const { resetPages, isMobileStyle } = usePage();
  const { convertStringToLink } = useContext(GlobalFunctionsContext);

  const [showMenu, setShowMenu] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;

      if (currentScroll < 600) {
        setShowMenu(true);
      } else {
        setShowMenu(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  
  const handleClickLink = (link) => {
    localStorage.removeItem('productoAgregado');
    resetPages();
    navigate(link);
  }

  const handleLogOut = () => {
    logout();
    navigate('/')
  }
  useEffect(() => {
    const params = {
      type: 'menu'
    }
    fetchCategoryListData(params)
      .then(data => {
        const categoriasConChunks = data.map(item => ({
          ...item,
          submenuChunked: item.submenu.length > 0 ? chunkArray(item.submenu, 10) : [],
        }));
        setCategorias(categoriasConChunks)}
      )
      .catch(err => {console.log(err)});
  }, []);

  return (
    <>
      <div className={`menu-fixed ${!isMobileStyle ? showMenu ? 'translate-y-full' : 'translate-y-0 z-0' : 'mobile'} ${lateral ? 'menu-lateral' : ''}`}>
        <div className="menu">
          <div className="menu-tags">{/*Iria los tags 
            <Button className="pink"><Percent /> Descuentos</Button>
            <Button className="blue"><Mortarboard /> Escolar</Button>*/}
          </div>
          <div className="menu-content">
            {categorias &&
              categorias.map((item,idx) => {
                let nombre = convertStringToLink(item.nombre);
                return (
                  <>
                    <div className="item">
                      <div key={`menu_${item.id}`} className={`menu-content-item ${item.submenu.length > 0 ? 'p-0' : ''}`}>
                        {item.submenu.length === 0 && (
                          <Button variant="link" onClick={() => {handleClickLink(`/categoria/${item.id}-${nombre}`)}}>{item.nombre}</Button>
                        )}
                        {item.submenu.length > 0 && (
                        <>
                          {lateral
                            ? <Accordion>
                              <Accordion.Item eventKey="0">
                                <Accordion.Header>{nombre}</Accordion.Header>
                                <Accordion.Body>
                                  <Button variant="link" onClick={() => {handleClickLink(`/categoria/${item.id}-${nombre}`)}}>Ver todos los productos</Button>
                                  <div className="menu-data-content">
                                    {item.submenuChunked && item.submenuChunked.map((chunk, idx) => (
                                      <div className="menu-data-list" key={`submenu_chunk_${idx}`}>
                                        {chunk.map((sub) => (
                                          <Button variant="link" key={`button_${sub.id}`} onClick={() => {handleClickLink(`/categoria/${sub.id}-${convertStringToLink(sub.nombre)}`)}}>
                                            <ChevronRight />{sub.nombre}
                                            
                                          </Button>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                </Accordion.Body>
                              </Accordion.Item>
                            </Accordion>
                            : <Dropdown>
                              <Dropdown.Toggle>
                                {nombre}
                              </Dropdown.Toggle>
                              <Dropdown.Menu className={`${!showMenu ? 'display-none' : ''}`}>
                                <div className="menu-dropdown-content">
                                  <div className="menu-title-content">
                                    <Dropdown.ItemText className="title-content">
                                        <div className="title">{nombre}</div>
                                        <div className="button-dropdown" >
                                          <Dropdown.Item onClick={() => {handleClickLink(`/categoria/${item.id}-${nombre}`)}}>Ver todos los productos</Dropdown.Item>
                                          <div className="icon">
                                            <ArrowRight />
                                          </div>
                                        </div>
                                    </Dropdown.ItemText>
                                  </div>
                                  <div className="menu-data-content">
                                  {item.submenuChunked && item.submenuChunked.map((chunk, idx) => (
                                    <div className="menu-data-list" key={`submenu_chunk_${idx}`}>
                                      {chunk.map((sub) => (
                                        <Dropdown.Item className="list-item" key={`button_${sub.id}`} onClick={() => {handleClickLink(`/categoria/${sub.id}-${convertStringToLink(sub.nombre)}`)}}>
                                          {sub.nombre}
                                          <ChevronRight />
                                        </Dropdown.Item>
                                      ))}
                                    </div>
                                  ))}
                                  </div>
                                </div>
                              </Dropdown.Menu>
                            </Dropdown>
                          }
                        </>
                        )}
                      </div>
                    </div>
                    {!lateral ? '|' : ''}
                  </>
                  );
                })}
            <div className="menu-content-item">
              <Button variant="link" onClick={() => {handleClickLink('/contacto')}}>Contacto</Button>
            </div>
            {lateral 
              ?<div className="account">
                {!isAuthenticated
                ?<>
                  <Button variant="link" onClick={() => {handleClickLink('/login')}}>
                    <LogIn />
                    Iniciar Sesion</Button>
                    <Button variant="link" onClick={() => {handleClickLink('/registro')}}>
                      <UserRoundPlus />
                      Registrate
                    </Button>
                  </>
                : <>
                  <Button variant="link" onClick={() => {handleClickLink('/perfil-usuario')}}>
                    <User />
                    Mi Cuenta
                  </Button>
                  <Button variant="link" onClick={() => {handleLogOut()}}>
                    <LogOut />
                    Cerrar Sesion
                  </Button>
                  </>
                }
              </div>
              : null
            }
            
          </div>
        </div>
      </div>
    </>
  )
}
